/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Group_MetaInputs */

const cs_draft_group_meta = /** @type {(inputs: Draft_Group_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta`)
};

const en_draft_group_meta = /** @type {(inputs: Draft_Group_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta`)
};

/**
* | output |
* | --- |
* | "Meta" |
*
* @param {Draft_Group_MetaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_group_meta = /** @type {((inputs?: Draft_Group_MetaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Group_MetaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_group_meta(inputs)
	return cs_draft_group_meta(inputs)
});